// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileTopic_wrapper__5LZor","topicName":"MobileTopic_topicName__KvBI+","arrowIcon":"MobileTopic_arrowIcon__SSRhV"};